var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rdText',[_vm._v(" "+_vm._s(_vm._f("formatEmpty")(_vm.row.contactName))+" ")]),_c('div',{staticClass:"yx-color-text-secondary font-h6-regular"},[_vm._v(" "+_vm._s(_vm._f("formatEmpty")(_vm.row.mobile))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }